import styled from '@emotion/styled';
import MUISlider from '@mui/material/Slider';
import { boxShadowMixins } from '@styles/mixins';
import { ThemeProps } from '@theme/base';

export const Slider = styled(MUISlider)(({ theme }: ThemeProps) => ({
  ['.MuiSlider-rail']: {
    height: 8,
    borderRadius: 8,
    opacity: 1,
    backgroundColor: theme.custom.colors.group10.light,
    boxShadow: boxShadowMixins(theme.custom.colors.group10.base).inset.default
  },

  ['.MuiSlider-track']: {
    height: 8,
    backgroundColor: theme.custom.colors.group1.base
  },

  ['.MuiSlider-thumb']: {
    width: theme.custom.spacing.medium,
    height: theme.custom.spacing.medium,
    backgroundColor: theme.custom.colors.white,
    boxShadow: boxShadowMixins(theme.custom.colors.group10.dark).glow,
    transition: `background-color ${theme.custom.transitions.default}, box-shadow ${theme.custom.transitions.fastSmooth}`,

    ['&:hover']: {
      backgroundColor: theme.custom.colors.group10.light,
      boxShadow: '0px 0px 0px 8px rgba(63, 81, 181, 0.16)'
    },

    ['&.MuiSlider-active']: {
      boxShadow: '0px 0px 0px 14px rgba(63, 81, 181, 0.16)'
    },

    ['&::after']: {
      top: 0,
      bottom: 0,
      right: 0,
      left: 0
    },

    ['.MuiSlider-valueLabel']: {
      ['& > span']: {
        transform: 'none',
        marginTop: theme.custom.spacing.xSmall,
        marginLeft: -4,
        width: 48,
        height: 32,
        padding: theme.custom.spacing.xSmall,
        boxShadow: 'none',
        borderRadius: 0,
        backgroundSize: '48px 32px',
        backgroundPosition: '0 2px',
        color: 'transparent',

        ['& > span']: {
          display: 'block',
          transform: 'none',
          color: theme.custom.colors.group4.base,
          ...(theme.custom.typography.labels.attribute as any),
          fontWeight: 500,
          backgroundColor: 'white',
          border: `1px solid ${theme.custom.colors.group10.light}`,
          padding: theme.custom.spacing.xSmall,
          textAlign: 'center',
          borderRadius: 2,
          '&::after': {
            content: '" "',
            position: 'absolute',
            display: 'block',
            bottom: -1,
            left: 'calc(50% - 3px)',
            width: 6,
            height: 6,
            background: 'white',
            borderRight: `1px solid ${theme.custom.colors.group10.light}`,
            borderBottom: `1px solid ${theme.custom.colors.group10.light}`,
            transform: 'rotate(45deg)'
          }
        }
      }
    }
  }
}));
